module.exports = __webpack_public_path__ + "img/2fa3e43.jpg";